<template>
    <div class="linked-accounts-summary shadow drei_60-border-1 drei_60-blue-border">
        <div class="linked-accounts-summary__icon drei_60-blue">
            <v-icon class="drei_60-white-text">mdi-link-variant</v-icon>
        </div>
        <div>
            <div v-if="sumAccounts() > 0">
                <div class="text-uppercase linked-accounts-summary__title mb-2">
                    <span>Verknüpfte Konten</span>
                    <v-spacer></v-spacer>
                    <v-tooltip right v-if="showButton">
                        <template #activator="{ on }">
                            <v-btn
                                v-on="on"
                                class="ma-0 drei_60-btn "
                                text icon small
                                @click="navigateLinkedAccountsOverview"
                            >
                                <v-icon>mdi-format-list-bulleted</v-icon>
                            </v-btn>
                        </template>
                        <span>Verknüpfte Konten verwalten</span>
                    </v-tooltip>
                </div>
                <hr>
                <div class="mt-2 font-weight-bold linked-accounts-summary__text">
                    <span>
                        Verknüpft: {{ assigned() }} <br/>
                        Verfügbar: {{ unassigned() }}
                    </span>
                </div>
            </div>
            <div v-if="isOwned() && showParent">
                <div class="text-uppercase linked-accounts-summary__title mb-2 mt-2">
                    <span>Verknüpfungen über Abo von</span>
                    <v-spacer></v-spacer>
                </div>
                <hr>
                <div class="mt-2 font-weight-bold linked-accounts-summary__text">
                    <div v-for="(item, index) in linkedAccounts.ownages" :key="index" style="display: flex;">
                            <div style="line-height: 35px;">{{ item.gender + ' ' + item.firstName + ' ' + item.lastName }} </div>
                            <v-spacer></v-spacer>
                            <OpenCustomerBtn
                                :ssoId="item.ssoId"
                                :alternativeBtn="false"
                                :disabled="loading"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Route from '@/route';
import OpenCustomerBtn from '@/components/customer/OpenCustomerBtn.vue';

export default {
    name: 'LinkedAccountsSummary',
    props: ['ssoId', 'linkedAccounts', 'loading', 'showButton', 'showParent'],
    components: {
        OpenCustomerBtn,
    },
    methods: {
        navigateLinkedAccountsOverview() {
            this.$router.push({
                name: Route.CUSTOMER_LINKED_ACCOUNTS.name,
                params: { sso_id: this.ssoId },
            });
        },
        assigned() {
            if (this.linkedAccounts) {
                return this.linkedAccounts.assigned;
            }
            return 0;
        },
        unassigned() {
            if (this.linkedAccounts) {
                return this.linkedAccounts.unassigned;
            }
            return 0;
        },
        sumAccounts() {
            return this.linkedAccounts.assigned + this.linkedAccounts.unassigned;
        },
        isOwned() {
            return (this.linkedAccounts.ownages && this.linkedAccounts.ownages.length > 0);
        },
    },
};

</script>
<style scoped lang="scss">

    .linked-accounts-summary {
        display: flex;
    }
    .linked-accounts-summary__title {
        display: flex;
        align-items: center;
    }

    .linked-accounts-summary__text {
        flex: none;
    }

    .linked-accounts-summary__target {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-content: baseline;
    }

    .linked-accounts-summary__icon {
        flex: none;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .linked-accounts-summary__icon + div {
        flex: 1;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
</style>
